/**
 * `/admin` — the tenant admin console, one route per section.
 *
 * Seven `useState` tabs became seven addresses, so a section is linkable and
 * a reload keeps the reader where they were.
 *
 * @module router/admin/AdminLayout
 */

import React from "react";

import { Outlet } from "react-router";

import { LinkTabs, PageHeader } from "@/components/ui";
import { ADMIN_AREA } from "@/router/admin/admin-area";

/** The sections, in the order the console lists them. */
export const ADMIN_SECTIONS = [
  { to: "/admin", label: "Users", end: true, "data-testid": "admin-tab-users" },
  { to: "/admin/programmes", label: "Programmes", "data-testid": "admin-tab-programmes" },
  { to: "/admin/provider", label: "Provider settings", "data-testid": "admin-tab-provider" },
  { to: "/admin/access", label: "Access", "data-testid": "admin-tab-access" },
  { to: "/admin/disciplines", label: "Disciplines", "data-testid": "admin-tab-disciplines" },
  { to: "/admin/teams", label: "Programme teams", "data-testid": "admin-tab-teams" },
  { to: "/admin/audit", label: "Audit trail", "data-testid": "admin-tab-audit" },
] as const;

export function AdminLayout(): React.ReactElement {
  return (
    <div className="space-y-6" data-testid="client-admin-console">
      <PageHeader
        title={ADMIN_AREA.client}
        description="See who is in this tenant, what they can do and what has changed."
      />
      <LinkTabs items={ADMIN_SECTIONS} aria-label="Admin console sections" />
      <Outlet />
    </div>
  );
}
